import Service from '@ember/service';
import { buildMockPeriodsSlice } from 'lumen/services/net-revenue/mock-data';
import type {
  NetRevenuePeriods,
  NetRevenuePeriodsArgs,
} from 'lumen/utils/net-revenue/types';

const MOCK_LATENCY_MS = 2000;

export default class NetRevenueService extends Service {
  // TODO: swap the mock for a real `fetch()` once the BE endpoint is live.
  getPeriods(args: NetRevenuePeriodsArgs): Promise<NetRevenuePeriods> {
    return new Promise((resolve) =>
      setTimeout(() => resolve(buildMockPeriodsSlice(args)), MOCK_LATENCY_MS),
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    'net-revenue': NetRevenueService;
  }
}
